//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const redeemStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#2F7CBD !important",
    color: "#fff",
    width: "initial !important",
    margin: "22px 40px 0 40px",
    fontFamily: "segoe-ui",
    "@media (max-width: 600px)": {
      margin: 0,
    },
  },
  appBarIcon: {
    fontSize: 34,
  },
  billToGrid: {
    padding: "40px 0px 30px 40px",
    "@media (max-width: 600px)": {
      padding: 10,
    },
  },
  billToText: {
    color: "#000000",
    fontWeight: "bold",
    fontSize: 28,
    fontFamily: "segoe-ui",
  },
  cardParentGrid: {
    padding: "0px 40px",
    fontFamily: "segoe-ui",
    marginTop: 50,
    "@media (max-width: 600px)": {
      padding: 10,
    },
  },
  cardChildGrid: {
    "@media (max-width: 600px)": {
      padding: "10px 0",
    },
  },
  appBarText: {
    fontSize: 34,
    verticalAlign: "middle",
    "@media (max-width: 600px)": {
      fontSize: 22,
    },
  },
  textField: {
    backgroundColor: "#E4E4E4",
  },
  border: {
    borderRadius: 20,
    cursor: "pointer",
    "@media (min-width: 1280px)": {
      margin: "0px",
      padding: 20,
      borderBottom: "none",
    },
  },
  grid: {
    marginBottom: "15%",
    "@media (min-width: 1280px)": {
      marginBottom: "5%",
    },
  },
  wordBreak: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "table",
    width: "100%",
    tableLayout: "fixed",
  },
  card: {
    backgroundColor: "#e4e4e4",
    borderRadius: 15,
    padding: 10,
    height: 110,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  pointsText: {
    fontSize: "1.125rem",
    fontWeight: "bold",
    color: "#6a6a6a",
    width: "100%",
    display: "inline-block",
  },
  pointsValue: {
    fontSize: "1.25rem",
    fontWeight: "bold",
  },
  cancelBtn: {
    backgroundColor: "#fff",
    color: "#2F7CBD!important",
    border: "1px solid #2F7CBD",
    width: 100,
    height: 40,
    fontSize: "0.875rem",
    fontWeight: "bold",
    textTransform: "uppercase",
    borderRadius: 10,
    // bottom: 150,
    // right: 200,
    // position: "absolute",
    margin: 20,
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  redeemBtn: {
    backgroundColor: "#40b2df",
    color: "#fff!important",
    fontSize: "0.875rem",
    fontWeight: "bold",
    textTransform: "uppercase",
    borderRadius: 10,
    width: 100,
    height: 40,
    // bottom: 150,
    // right: 20,
    // position: "absolute",
    margin: 20,
    "&:hover": {
      backgroundColor: "#40b2df",
    },
  },

  redeemBtnca: {
    backgroundColor: "#8f1e5f",
    color: "#fff!important",
    fontSize: "0.875rem",
    fontWeight: "bold",
    textTransform: "uppercase",
    borderRadius: 10,
    width: 100,
    height: 40,
    // bottom: 150,
    // right: 20,
    // position: "absolute",
    margin: 20,
    "&:hover": {
      backgroundColor: "#8f1e5f",
    },
  },

 
  divGrid: {
    border: "2px solid #3891CB",
    borderRadius: 15,
    textAlign: "center",
    width: "70%",
    background: "#f6f9fc",
    minWidth: "600px",
  },
  gridContainer: {
    justifyContent: "center",
  },
  gridOne: {
    textAlign: "center",
    padding: 10,
  },
  griTwo: {
    textAlign: "-webkit-center",
  },
  gridDivOne: {
    fontSize: "1.125rem",
    fontWeight: "bold",
    color: "#6a6a6a",
    width: "100%",
  },
  gridDivTwo: {
    fontSize: "1.25rem",
    fontWeight: "bold",
  },

  gridDivFour: {
    fontWeight: "bold",
    padding: 10,
    fontSize: "22px",
  },
  gridDivFive: {
    fontWeight: "bold",
    backgroundColor: "#d8e2f3",
    padding: 10,
    fontSize: "1rem",
    display:"flex",
    justifyContent:"space-around"
  },
  gridDivSix: {
    padding: 10,
    fontSize: "1rem",
  },
  gridDivSeven: {
    padding: "10px 0px 0px 0px",
    fontWeight: "bold",
    marginBottom: "5px",
  },
  gridSpanOne: {
    width: "100%",
    display: "inline-block",
  },
  textField: {
    width: "70%",
    height: 55,
  },
  textAlignCenter: {
    textAlign: "center",
  },
  credit: {
    padding: "20px 0px 10px 0px",
    fontSize: "1rem",
    fontWeight: "bold",
    color: "#2F7CBD",
  },
  errorText: {
    color: "red",
  },

  bronzenof: {
    fontWeight: "bold",
    // backgroundColor: "#d8e2f3",
    // padding: 10,
    fontSize: "1rem",
    marginTop : '7%',
    // marginLeft: 88
    textAlign:'center'
  },
}));

export const redeemConfirmationStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#2F7CBD",
    color: "#fff",
    width: "initial",
    margin: "22px 40px 0 40px",
    "@media (max-width: 600px)": {
      margin: 0,
    },
  },
  parentGrid: {
    padding: "20px 40px 0px 40px",
    "@media (max-width: 600px)": {
      padding: 10,
    },
  },
  tableGrid: {
    marginTop: 10,
    "@media (max-width: 600px)": {
      margin: "10px 0",
    },
  },
  textField: {
    backgroundColor: "#E4E4E4",
  },
  border: {
    margin: "0px 8px",
    borderBottom: "1px solid gray",
    borderRadius: 10,
    "@media (min-width: 1280px)": {
      margin: "0px",
      padding: "25px 15px",
      borderBottom: "none",
    },
  },
  grid: {
    marginBottom: "15%",
    "@media (min-width: 1280px)": {
      marginBottom: "5%",
    },
  },
  wordBreak: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "table",
    width: "100%",
    tableLayout: "fixed",
  },
  card: {
    backgroundColor: "#e4e4e4",
    height: 110,
    borderRadius: 15,
    padding: 10,
    margin: "0px 20px",
  },
  pointsText: {
    fontSize: "1.125rem",
    fontWeight: "bold",
    color: "#6a6a6a",
  },
  pointsValue: {
    fontSize: "1.25rem",
    fontWeight: "bold",
  },
  goToDashboardBtn: {
    backgroundColor: "#2F7CBD",
    color: "#fff!important",
    height: 56,
    fontSize: "1.125rem",
    fontWeight: "bold",
    textTransform: "capitalize",
    borderRadius: 10,
    right: 40,
    marginTop: 40,
    position: "absolute",
    "&:hover": {
      backgroundColor: "#2F7CBD",
    },
  },
  // content
  contentGrid: {
    textAlign: "center",
    // padding: "50px 0",
  },
  content1: {
    padding: 30,
    textAlign: "center",
  },
  congratsImg: {
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  content2: {
    fontSize: "1.25rem",
  },
  content2Span: {
    fontWeight: "bold",
  },
  content3: {
    fontSize: "1.25rem",
    marginBottom: "1.25rem",
  },
  content3Span: {
    fontWeight: "bold",
  },
  content4: {
    fontSize: "0.875rem",
    // padding: "30px 30px",
  },
  content5: {
    fontSize: "1rem",
    fontWeight: "bold",
    padding: "1.25rem",
    color: "#8f1e5f",
  },
  content5Span: {
    cursor: "pointer",
    textDecoration: "underline",
    color:"#40b2df"
  },
  content5Spanca: {
    cursor: "pointer",
    textDecoration: "underline",
  },
  threeBtnsGrid: {
    display: "flex",
    justifyContent: "space-around",
    marginBottom: 20,
    "@media (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  pointsBalanceBtn: {
    width: 100,
    height: 35,
    background: "#233d75",
    border: "none",
    color: "#fff",
    borderRadius: "5px",
  },
  btnSection: {
    "@media (max-width: 600px)": {
      marginBottom: 20,
    },
  },
}));
